export default __webpack_public_path__ + "static/media/md-card-bg-excel.39fbc6cb.png";